import { Alert, AlertTitle, AlertDescription, AlertSeverityIcon } from '@safe-global/views/components/ui/alert'
import useWallet from '@/hooks/wallets/useWallet'
import ConnectWalletButton from '@/components/common/ConnectWallet/ConnectWalletButton'

const NoWalletConnectedWarning = () => {
  const wallet = useWallet()

  if (wallet) {
    return null
  }

  return (
    <Alert variant="warning" outlined={false} className="mt-6">
      <AlertSeverityIcon variant="warning" />
      <AlertTitle className="font-bold">No wallet connected</AlertTitle>
      <AlertDescription>
        You need to connect a wallet to create a Safe account.
        <div className="mt-4">
          <ConnectWalletButton variant="outline" className="text-foreground" />
        </div>
      </AlertDescription>
    </Alert>
  )
}

export default NoWalletConnectedWarning
